import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {APPLY_CATEGORY, USER_ATTRIBUTE} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedDate} from '../helper/NatBicycleParkingUseApplyHelper'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    useArea: Nullable<string>
    useStartDate: Nullable<string>
    userFamilyName: Nullable<string>
    userFirstName: Nullable<string>
    userAttribute: Nullable<string>
    ownerFamilyName: Nullable<string>
    ownerFirstName: Nullable<string>
    bicycleRegistrationNumber: Nullable<string>
    applyFlag?: boolean
}

const NatResidentBicycleParkingUseApplyConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, useArea, useStartDate,
        userFamilyName, userFirstName, userAttribute,
        ownerFamilyName, ownerFirstName, bicycleRegistrationNumber
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.BICYCLE_PARKING_USE_APPLY.label
    const useStartDateLabel = (useStartDate) ?
        getFormattedDate(useStartDate) : ''

    const userAttributeLabel = (userAttribute) ?
        USER_ATTRIBUTE.codeToEnumConstants(userAttribute).label : ''

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'使用区画'}
            items={[`${useArea}`]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'使用開始日'}
            items={[useStartDateLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'使用者'}
            items={[`${userFamilyName} ${userFirstName}` + '（' + `${userAttributeLabel}` + '）']}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'自転車情報'}
            items={['所有者：' + `${ownerFamilyName} ${ownerFirstName}` ,
                '自転車登録番号（防犯登録番号）：' + `${bicycleRegistrationNumber}`]}
        />
    </>)
}

NatResidentBicycleParkingUseApplyConfirm.displayName = 'NatResidentBicycleParkingUseApplyConfirm'
export default NatResidentBicycleParkingUseApplyConfirm